module.exports = __webpack_public_path__ + "static/img/dataLeakInstallForMac_pic2.72c70ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dataLeakInstallForMac/dataLeakInstallForMac_pic2.png
// module id = 481
// module chunks = 1